module.exports = __webpack_public_path__ + "static/media/tom_cole_pic_6.a0473eca.jpg";